import { useState } from 'react';
import { entryTabs } from '@/mocks/home';

export default function EntryTabs() {
  const [activeKey, setActiveKey] = useState(entryTabs[0].key);
  const active = entryTabs.find((item) => item.key === activeKey) ?? entryTabs[0];

  return (
    <section id="entry" className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="text-[11px] tracking-[0.3em] text-secondary-700 mb-3">五个入口</div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              从哪一角切进去，都行
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            放大、细节、同款、背景、反光，五条线各自独立，也能互相对照。
          </p>
        </div>

        <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 mb-8 max-w-full overflow-x-auto">
          {entryTabs.map((tab) => {
            const isActive = tab.key === activeKey;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveKey(tab.key)}
                className={
                  'flex items-center gap-1.5 px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ' +
                  (isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-primary-600')
                }
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={tab.icon}></i>
                </span>
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="w-full h-[280px] md:h-[380px] rounded-lg overflow-hidden bg-background-200">
              <img
                src={active.image}
                alt={`私拍吃瓜${active.label} 入口配图`}
                title={`私拍吃瓜${active.label} 细节对照`}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="lg:col-span-6">
            <h3 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-4 leading-snug">
              {active.title}
            </h3>
            <p className="text-sm md:text-base leading-relaxed text-foreground-600 mb-8">{active.desc}</p>
            <div className="flex flex-wrap items-center gap-8">
              {active.stats.map((stat) => (
                <div key={stat.label} className="flex items-baseline gap-2">
                  <span className="font-heading text-2xl md:text-3xl font-bold text-accent-600">
                    {stat.value}
                  </span>
                  <span className="text-xs text-foreground-500">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}